export default {
  common: {
    confirm: 'Bevestig',
    cancel: 'Annuleer',
    search: 'Zoek',
    copy: 'KOPIEER',
    next: 'VOLGENDE',
    question_mark: '? ',
    testnet: 'Testnet',
    mainnet: 'Htmlcoin Mainnet',
    menu: {
      create: 'Maak een nieuwe portemonnee aan',
      create_from_mnemonic: 'Aanmaken via ezelsbruggetje',
      restore_from_mnemonic: 'Herstel via ezelsbruggetje',
      restore_from_wif: 'Herstel via WIF',
      restore_from_mobile: 'Herstel via mobiele portemonnee',
      restore_from_key_file: 'Herstel via sleutelbestand',
      restore_from_ledger: 'Herstel via Ledger',
      view: 'Toon algemeen overzicht van uw portemonnee',
      dump_as_key_file: 'Dump als een sleutelbestand',
      transactions: 'Blader door transactiegeschiedenis',
      safe_send: 'Veilig Versturen',
      send: 'Verstuur',
      request_payment: 'Betalingsverzoek',
      create_token: 'Token aanmaken',
      create_contract: 'Contract aanmaken',
      send_to_contract: 'Verstuur naar contract',
      call_contract: 'Oproepen van contract',
      settings: 'Instellingen',
    },
    info: {
      address: 'Adres',
      balance: 'Overzicht',
      unconfirmed_balance: 'Onbevestigde balans',
      priv_key: 'Privésleutel',
    },
    notify: {
      success: 'Succes',
      fail: 'Mislukt',
      copy: 'Kopie',
      password: 'Wachtwoord',
      is_required: 'is vereist',
      parse: 'Ontleden',
      file: 'Bestand',
      password_is_not_same_as_the_old_one: 'Wachtwoord is niet hetzelfde als de oude',
      mnemonics_are_not_same_as_the_words_should_remember: 'De ezelbruggetjes komen niet overeen',
      mnemonics_can_not_restore: 'De ezelbruggetjes kunnen de portemonnee niet herstellen, controleer alstublieft en probeer het opnieuw',
      address_is_not_same_as_the_old_one: 'Dit adres is niet hetzelfde als het oude',
      from_address_is_not_same_as_the_wallet: 'Het verstuuradres is niet hetzelfde als het adres van de portemonnee',
      restore_wif_fail: 'Kan geen portemonnee herstellen van deze WIF',
      the_key_file_is_not_a_valid_format: 'Het sleutelbestand heeft geen geldig bestandsformaat',
      restore_key_file_fail: 'Herstel van sleutelbestand mislukt. Misschien is het wachtwoord niet juist',
      connect_ledger_fail: 'Verbinding met Ledger mislukt. Verbind uw Ledger opnieuw en probeer het nogmaals',
      token_contract_address_is_not_exists: 'Het contractadres van de token bestaat niet, controleer het alstublieft en probeer het nogmaals',
    },
    mode: {
      normal: 'Normaal',
      offline: 'Niet verbonden',
    }
  },
  mnemonic: {
    input_words: 'Voer alstublieft de woorden in',
    label: 'M'
  },
  password: {
    enter: 'Voer alstublieft uw wachtwoord in',
    password: 'Wachtwoord',
  },
  file_reader: {
    upload: 'Upload',
  },
  file_creator: {
    download: 'Klik alstublieft op deze knop om uw backup te downloaden. Als de download niet start klikt u dan op uw rechtermuisknop en kies vervolgens “Koppeling opslaan als…”',
  },
  ledger: {
    comm_fail: 'Verbinding met Ledger mislukt. Verbind uw Ledger opnieuw en probeer het nogmaals.',
  },
  derive_path: {
    title: 'Kies alstublieft een aangepaste gegevensmap',
    default: 'Standaard gegevensmap',
    add_custom: 'Voeg een aangepaste gegevensmap toe',
    edit_custom: 'Bewerk aangepaste gegevensmap',
    del_custom: 'Bevestigt u om deze gegevensmap te verwijderen',
    path_name: 'Naam gegegevensmap',
    path: 'Gegevensmap',
    prev_10: 'Vorige 10 adressen',
    next_10: 'Volgende 10 adressen',
  },
  safe_send: {
    title: 'Veilig Versturen',
    from_address: 'Van Adres',
    to_address: 'Naar Adres',
    amount: 'Bedrag',
    fee: 'Transactiekosten',
    info: 'U heeft twee computers nodig (één met internetverbinding en één zonder internetverbinding) en een uitneembaar apparaat voor opslag om een ‘Veilig Versturen’ af te ronden. Als u onderstaande tips volgt loopt u geen risico op het openbaar maken van uw privésleutel. Voor de computer zonder internetverbinding, kies bij ‘Instellingen’-‘Modus’ voor ‘Zonder verbinding’ en herstel vervolgens uw portemonnee.',
    info1_online: 'Vul alstublieft het formulier in, bewaar het bestand en kopieer het naar de computer zonder internetverbinding. Volg hierna stap 2 op de computer zonder internetverbinding',
    info1_offline: 'Voer alstublieft stap 1 uit op de computer met internetverbinding en kopieer het bestand van deze computer en ga vervolgens naar stap 2',
    info2_online: 'Voer deze stap alstublieft uit op de computer zonder internetverbinding, kopieer het bestand van deze computer en ga hierna naar stap 3',
    info2_offline: 'Upload alstublieft de kopie van het bestand van de computer met internetverbinding, bevestig de handtekening en bewaar het bestand, kopieer het vervolgens terug naar de computer met internetverbinding',
    info3_online: 'Upload alstublieft het bestand van de computer zonder internetverbinding om ‘Veilig Versturen’ af te ronden',
    info3_offline: 'Rond deze stap alstublieft af op de computer met internetverbinding',
  },
  send: {
    send_tokens: 'Verstuur',
    enter_address: 'Voer het adres opnieuw in alstublieft (dubbele controle)',
    going_to_send: 'U gaat versturen ',
    to_address: 'naar adres ',
    token_address: 'naar adres',
  },
  request_payment: {
    title: 'Betalingsverzoek',
  },
  create_token: {
    title: 'Token Aanmaken',
    name: 'Naam Token',
    symbol: 'Symbool Token',
    decimal: 'Decimalen (het is verstandig om 8 decimalen te gebruiken met HTMLCOIN)',
    total_supply: 'Totale Aanbod (EENHEID: 1 Token)',
    confirm: 'Bevestigt u om deze Token aan te maken?',
  },
  create_contract: {
    title: 'Maak contract aan',
    confirm: 'Bevestigt u om het contract openbaar te maken?',
    compiler: 'Verzamelaar',
  },
  send_to_contract: {
    title: 'Verstuur naar contract',
    confirm: 'Bevestigt u dit?',
  },
  call_contract: {
    title: 'Contract oproepen',
    result: 'Resultaat',
  },
  create: {
    title: 'Nieuwe portemonnee aanmaken',
  },
  create_mnemonic: {
    title: 'Generate New Wallet',
    remember: 'Onthoud de volgende ezelsbruggetjes alstublieft',
    remembered: 'Ik heb het allemaal onthouden. Laten wij het controleren',
  },
  restore: {
    title: 'Herstel portemonnee',
    mnemonic_warning: 'De ingevoerde woorden zijn niet bip39 ezelsbruggetjes. Als uw adres is aangemaakt door deze portemonnee, sluit dan dit dialoog en controleer de gebruikte woorden (geen spatie, geen hoofdletter, enz.). U kan doorgaan wanneer u uw woorden heeft gecontroleerd.',
  },
  restore_wif: {
    title: 'Herstel portemonneee via WIF',
    priv_key: 'WIF',
  },
  restore_mobile: {
    title: 'Herstel via mobiele portemonnee',
  },
  restore_key_file: {
    title: 'Herstel via sleutelbestand',
    password_title: 'Voer alstublieft uw wachtwoord in om de portemonnee te ontcijferen',
  },
  restore_ledger: {
    title: 'Herstel via Ledger',
    usage: 'Controleer alstublieft dat uw firmware en app de nieuwste versies zijn. Verbind uw Ledger, open de Html APP en klik vervolgens op de knop ‘VERBIND’ om verbinding te leggen.',
    download: 'Installeren kan via de link https://www.ledgerwallet.com/apps/manager',
    connect: 'VERBIND',
  },
  view: {
    title: 'Toon algemeen overzicht van uw portemonnee',
  },
  view_tx: {
    title: 'Blader door transactiegeschiedenis',
    recent: 'Meest recente 10 transacties',
    tx: 'Tx: ',
    mined_at: 'Gemined om ',
    total_in: 'Totaal in ',
    fee: 'Transactiekosten ',
    total_out: 'Totaal uit ',
  },
  dump_as_key_file: {
    title: 'Dumo als sleutelbestand',
    password_title: 'Voer alstublieft een wachtwoord in om uw portemonnee te versleutelen',
    warning: 'Onthoud dit wachtwoord alstublieft, als u dit wachtwoord verliest kan de backup niet worden ontcijferd',
  },
  config: {
    title: 'Instellingen',
    lan: 'Taal',
    network: 'Netwerk',
    mode: 'Modus',
  },
  warning: {
    title: 'Waarschuwing',
    list: [
      'Wij kunnen uw fondsen niet herstellen wanneer u een phishing-website bezoekt of uw backup verliest. Bewaar alstublieft backups van uw privésleutels/ezelsbruggetjes.',
      'Wij bewaren geen privésleutels/ezelsburggetjes op deze webportemonnee',
      'Als gebruiker bent u volledig verantwoordelijk voor de veiligheid van uw fondsen',
      'Gebruik altublieft de meest recente versie van zowel een anti-virus programma als besturingssysteem',
      'Bewaar alstublieft uw privésleutels en deel deze met niemand.',
      'Zorg ervoor dat bij gebruik van ‘Herstel via Ezelsbruggetje’ de gebruikte woorden en het wachtwoord exact overeen komen, anders zal een nieuw adres door de portemonnee worden aangemaakt. Zorg dus voor gebruik van het juiste adres bij het herstellen via het ezelsbruggetje.',
    ]
  }
}



// WEBPACK FOOTER //
// ./src/locales/nl.js